class CartWaiver {
  constructor() {
    this.form = document.querySelector('form[action="/cart"]');
    this.checkoutButtons = document.querySelectorAll('button[name="checkout"], input[name="checkout"]');
    this.waiverCheckbox = document.querySelector('#Cart-Waiver');
    this.sponsorshipCheckbox = document.querySelector('#Cart-Sponsorship-Terms');
    this.setupWaiverCheckbox();
  }

  setupWaiverCheckbox() {
    if (!this.checkoutButtons.length) return;

    // Handle checkout button clicks
    this.checkoutButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        if (!this.validateCheckboxes()) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    });

    // Handle form submission as backup
    if (this.form) {
      this.form.addEventListener('submit', (event) => {
        if (!this.validateCheckboxes()) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    }

    // Handle waiver checkbox label click
    if (this.waiverCheckbox) {
      const waiverLabel = document.querySelector('label[for="Cart-Waiver"]');
      if (waiverLabel) {
        waiverLabel.addEventListener('click', (event) => {
          if (event.target.tagName !== 'A') {
            this.waiverCheckbox.checked = !this.waiverCheckbox.checked;
            event.preventDefault();
          }
        });
      }
    }

    // Handle sponsorship checkbox label click
    if (this.sponsorshipCheckbox) {
      const sponsorshipLabel = document.querySelector('label[for="Cart-Sponsorship-Terms"]');
      if (sponsorshipLabel) {
        sponsorshipLabel.addEventListener('click', (event) => {
          if (event.target.tagName !== 'A') {
            this.sponsorshipCheckbox.checked = !this.sponsorshipCheckbox.checked;
            event.preventDefault();
          }
        });
      }
    }
  }

  validateCheckboxes() {
    let isValid = true;
    let missingCheckboxes = [];

    // Check waiver checkbox if it exists
    if (this.waiverCheckbox && !this.waiverCheckbox.checked) {
      isValid = false;
      missingCheckboxes.push('waiver terms');
    }

    // Check sponsorship checkbox if it exists
    if (this.sponsorshipCheckbox && !this.sponsorshipCheckbox.checked) {
      isValid = false;
      missingCheckboxes.push('sponsorship terms and conditions');
    }

    if (!isValid) {
      const message =
        missingCheckboxes.length === 1
          ? `Please agree to the ${missingCheckboxes[0]} before proceeding to checkout.`
          : `Please agree to the ${missingCheckboxes.join(' and ')} before proceeding to checkout.`;

      alert(message);

      // Focus the first unchecked checkbox
      if (this.waiverCheckbox && !this.waiverCheckbox.checked) {
        this.waiverCheckbox.focus();
      } else if (this.sponsorshipCheckbox && !this.sponsorshipCheckbox.checked) {
        this.sponsorshipCheckbox.focus();
      }
    }

    return isValid;
  }
}

// Initialize the cart waiver functionality when the DOM is ready
window.addEventListener('DOMContentLoaded', () => {
  new CartWaiver();
});
